import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { USER_ROLES } from '../../../constants'
import useUserStore from '../../../store/UserStore'
import Sidebar from '../Sidebar'
import './AdminLayout.scss'

const PAGE_TITLES: Record<string, string> = {
  '/admin/dashboard': 'Dashboard',
  '/admin/users': 'Users',
  '/admin/users/detail': 'User Details',
  '/admin/heroes': 'Heroes',
  '/admin/chess-apis': 'Chess Engine Analytics',
  '/admin/tournaments': 'Tournaments',
  '/admin/app-config': 'App Config'
}

const AdminLayout = () => {
  const { user } = useUserStore()
  const location = useLocation()

  if (!user || user?.role !== USER_ROLES.ADMIN) {
    return <Navigate to="/login" replace />
  }

  const pageTitle = PAGE_TITLES[location.pathname] || 'Admin Panel'

  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="admin-main">
        <header className="admin-topbar">
          <div className="topbar-left">
            <h2 className="topbar-title">{pageTitle}</h2>
          </div>
          <div className="topbar-right">
            <div className="topbar-user">
              <div className="topbar-user-avatar">
                {user?.userName?.charAt(0)?.toUpperCase() || 'A'}
              </div>
              <div className="topbar-user-info">
                <span className="topbar-user-name">{user?.userName || 'Admin'}</span>
                <span className="topbar-user-role">Administrator</span>
              </div>
            </div>
          </div>
        </header>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default AdminLayout
